module.exports = __webpack_public_path__ + "static/media/colorMap.bfa71897.jpeg";